import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=c4460c46&scoped=true"
import script from "./UpdateAddress.vue?vue&type=script&lang=js"
export * from "./UpdateAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4460c46",
  null
  
)

export default component.exports